import React from 'react';
import styles from './split-container.module.css';

interface SplitContainerProps {
  topComponent: React.ReactNode;
  bottomComponent: React.ReactNode;
}

export default function SplitContainer({
  topComponent,
  bottomComponent,
}: SplitContainerProps) {
  return (
    <div className={styles.container}>
      <div className={styles.top}>{topComponent}</div>
      <div className={styles.bottom}>{bottomComponent}</div>
    </div>
  );
}
